module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_LCS_Terrapin.edbf6c2e.jpeg";